import './App.css';
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import 'mapbox-gl/dist/mapbox-gl.css';
import React, { useRef, useState, useEffect } from 'react';
import SlyImg from './img/Sly.png';
import BootsieImg from './img/Bootsie.png';
import SplashImg from './img/Splash.png';
import TheoImg from './img/theo.png';
import ArrowFocus from './img/arrow-focus.svg';

const url = 'https://us-central1-massanutten-app-b41ef.cloudfunctions.net/mascotTracking-getLocations';
mapboxgl.accessToken = 'pk.eyJ1IjoibWFzc2FudXR0ZW5hcHAiLCJhIjoiY2sybnJoOXR0MDVnbjNtbWJ6dnk4OWJyMiJ9.MipwLjNv_tMeRd7pmWKCWg'; // replace this with your access token

console.log("version 1.0.0");
const images = {
  theo: TheoImg,
  bootsie: BootsieImg,
  sly: SlyImg,
  splash: SplashImg
}

function App() {
  const mapContainer = useRef(null);
  const map = useRef(null);
  const [lng, setLng] = useState(-78.716122);
  const [lat, setLat] = useState(38.406236);
  const [zoom, setZoom] = useState(14);
  const [mascots, setMascots] = useState([]);
  const [currentMascot, setCurrentMascot] = useState({});

  useEffect(() => {
    if (map.current) return; // initialize map only once
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/massanuttenapp/ck37mo31512y31cnknzzfm83n',
      center: [lng, lat],
      zoom: zoom
    });

    map.current.on('load', async function () {
      var res = await fetch(url);
      var mascots = await res.json();
      if (mascots) {
        console.log(mascots, 'mascots');
        setMascots(mascots);
      }
      var initialMascot = mascots[0];
      setCurrentMascot(initialMascot);
      flyTo(initialMascot);
      mascots.forEach(mascot => {
        const mascotName = mascot.properties.name.toLowerCase();
        map.current.loadImage(images[mascotName],
          function (errpr, image) {
            console.log(mascot, 'ms')
            map.current.addImage(`${mascotName}-img`, image);
            map.current.addSource(`${mascotName}`, { type: 'geojson', data: mascot });

            map.current.addLayer({
              'id': mascotName,
              'type': 'symbol',
              'source': mascotName,
              'layout': {
                'icon-image': `${mascotName}-img`,
                'icon-size': 0.1,
                'icon-allow-overlap': true
              }
            });
          })
      })
      window.setTimeout(fetchLocation, 200);
      window.setInterval(fetchLocation, 10000);
    });
  }, []);


  function flyTo(mascotToFly) {
    const mascot = mascotToFly ? mascotToFly : currentMascot;
    console.log(mascot, 'fly to')
    map.current.flyTo({
      center: mascot.geometry.coordinates,
      speed: 2
    })
  }

  function fetchLocation() {
    var request = new XMLHttpRequest();
    // make a GET request to parse the GeoJSON at the url
    request.open('GET', url, true);
    request.onload = function () {
      if (this.status >= 200 && this.status < 400) {
        var mascots = JSON.parse(this.response);
        setMascots(mascots);
        mascots.forEach(mascot => {
          console.log(mascot, 'mascot')
          // update the drone symbol's location on the map
          map.current.getSource(mascot.properties.name.toLowerCase()).setData(mascot);
          console.log(mascot.properties.name.toLowerCase(), 'name');
        })
      }
    };
    request.send();
  }


  function dropdownChange(e) {
    const mascot = mascots.find(m => m.properties.name.toLowerCase() === e.target.value.toLowerCase());
    setCurrentMascot(mascot);
    flyTo(mascot);
  };

  function goToCurrent() {

    let current = mascots.find(m => m.properties.name.toLowerCase() === currentMascot.properties.name.toLowerCase());
    flyTo(current);
    setCurrentMascot(current);
  }

  const dropdown = mascots.map(m => <option key={m.properties.name} value={m.properties.name}>{m.properties.name}</option>)

  return (<>
    <div ref={mapContainer} className="map-container"></div>
    <div className='dropdown-div'>
      <select className={`dropdown btn`} onChange={dropdownChange} value={currentMascot.properties ? currentMascot.properties.value : ""}>
        {dropdown}
      </select>
      <img className='arrow-focus' onClick={() => goToCurrent()} src={ArrowFocus} />
    </div>
  </>
  );
}

export default App;
